import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="footer-left">
          <span>© {new Date().getFullYear()} <b>SVEC Pvt Ltd.</b> All rights reserved.</span>
        </div>

        <div className="footer-social" aria-label="Social links">
          <a href="#" aria-label="Facebook" className="social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07c0 4.99 3.66 9.13 8.44 9.93v-7.03H8.08v-2.9h2.36V9.41c0-2.33 1.38-3.61 3.49-3.61.99 0 2.03.18 2.03.18v2.23h-1.14c-1.12 0-1.47.7-1.47 1.42v1.71h2.5l-.4 2.9h-2.1V22C18.34 21.2 22 17.06 22 12.07z"/></svg>
          </a>
          <a href="#" aria-label="Twitter" className="social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M22 5.92c-.63.28-1.3.48-2 .57.72-.43 1.27-1.11 1.53-1.92-.68.4-1.43.68-2.23.83A3.5 3.5 0 0012.6 8.5c0 .28.03.55.09.81-2.91-.15-5.5-1.54-7.23-3.66-.3.52-.47 1.12-.47 1.76 0 1.21.62 2.28 1.56 2.9-.58-.02-1.12-.18-1.59-.44v.05c0 1.7 1.21 3.12 2.82 3.44-.3.08-.61.12-.93.12-.23 0-.46-.02-.68-.07.46 1.44 1.79 2.49 3.37 2.52A7.02 7.02 0 012 19.54 9.9 9.9 0 007.29 21c6.86 0 10.62-5.75 10.62-10.73v-.49c.73-.53 1.36-1.2 1.86-1.96-.66.29-1.37.48-2.11.56z"/></svg>
          </a>
          <a href="#" aria-label="LinkedIn" className="social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v16H0zM8 8h4.8v2.2h.1c.7-1.3 2.4-2.2 4-2.2C21.9 8 24 10.1 24 13.9V24h-5v-9.4c0-2.2-.04-5-3-5-3 0-3.5 2.3-3.5 4.8V24H8V8z"/></svg>
          </a>
          <a href="#" aria-label="Instagram" className="social-link">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5.7A4.3 4.3 0 1016.3 12 4.3 4.3 0 0012 7.7zm6.4-1.1a1.1 1.1 0 11-1.1-1.1 1.1 1.1 0 011.1 1.1zM12 9.5A2.5 2.5 0 1112 14.5 2.5 2.5 0 0112 9.5z"/></svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
